import React from "react";
import { bindActionCreators } from "redux";
import connect from "react-redux/es/connect/connect";
import * as Actions from "./Store/Actions/EmpresaProdutoActions";
import EmpresaProdutoApp from "./EmpresaProdutoApp";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import PropTypes from "prop-types";

const EmpresaProdutoToggleButton = ({ get, callback, idpessoaformulario, idparent, xappRouteParams, iconProps, type = "edit", className, openNewDialog }) => {

    return (
        <React.Fragment>
            <div onKeyDown={ev => ev.stopPropagation()}>
                <EmpresaProdutoApp
                    isButton={true}
                    callback={callback}
                    idparent={idparent}
                />
            </div>
            {type === "edit" ?
                <React.Fragment>
                    {idpessoaformulario &&
                        <XAPPButton
                            tooltip={{ "title": "Editar", "placement": "top" }}
                            type="Icon"
                            iconProps={iconProps}
                            className={className}
                            onClick={() => get(idpessoaformulario, xappRouteParams)}
                            icon={"edit"}
                        />
                    }
                </React.Fragment>
                :
                <XAPPButton
                    tooltip={{ "title": "Adicionar", "placement": "top" }}
                    type="Icon"
                    iconProps={iconProps}
                    className={className}
                    onClick={() => openNewDialog()}
                    icon={"add"}
                />
            }
        </React.Fragment>
    );
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        get: Actions.get,
        openNewDialog: Actions.openNewDialog
    }, dispatch);
}

EmpresaProdutoToggleButton.propTypes = {
    get: PropTypes.func,
    callback: PropTypes.func,
    openNewDialog: PropTypes.func,
    className: PropTypes.string,
    type: PropTypes.string,
    idpessoaformulario: PropTypes.string,
    idparent: PropTypes.string,
    iconProps: PropTypes.string,
    xappRouteParams: PropTypes.object
};

export default connect(null, mapDispatchToProps)(EmpresaProdutoToggleButton);
